// extracted by mini-css-extract-plugin
module.exports = {"row":"a10a3f92e9--row--gyqhG","cell":"a10a3f92e9--cell--VElx0"};